import { useState, useEffect } from "react";
import "./PinLoginPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";
import { authService } from "../../../../../App";
import { authUserSignal } from "../../../../../signals/authSignal";
import { createLogger } from "../../../../../utils/logger";

const logger = createLogger("PinLoginPage");


const PinLoginPage = () => {

  const appVersion = `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`

  const [pinString, setPinString] = useState<string>("");
  const [showDigits, setShowDigits] = useState(false); // by default hide digits
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/search";

  const onClickDigit = (event: React.MouseEvent<HTMLButtonElement>) => {
    //event.currentTarget always refers to the button element itself,
    //avoiding issues when the click target is a child text node.
    const digit = event.currentTarget.dataset.digit;
    if (pinString.length < 10) {
      setPinString(pinString + "" + digit);
    }
  };

  // Handle keyboard number input (desktop only)
  useEffect(() => {
    const isDesktop = window.innerWidth > 768;
    if (!isDesktop) return;

    const handleKeydown = (e: KeyboardEvent) => {
      const key = e.key;

      if (key >= '0' && key <= '9') {
        e.preventDefault();
        const digit = key;
        if (pinString.length < 10) {
          setPinString(pinString + digit);
        }
      } else if (key === 'Backspace') {
        e.preventDefault();
        clearPin();
      } else if (key === 'Enter') {
        e.preventDefault();
        handleLogin();
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return () => window.removeEventListener('keydown', handleKeydown);
  }, [pinString, processing]);


  const clearPin = () => {
    if (pinString.length > 0) {
      let arr = pinString.split("");
      //console.log(arr.slice(0,arr.length-1).join());
      setPinString(arr.slice(0, arr.length - 1).join(""));
    }
  };
  const handleLogin = async () => {

    if(!processing){
      setProcessing(true);
      const result = await authService.login(pinString);
      logger.debug('handleLogin: success=', result);
      if (result) {
        const user = await authService.readUser();
  
        //signal
        authUserSignal.value = user;
  
        //setAuth(user)
        //navigate(from , {replace:true});
        
        logger.debug('redirect to=', from);
        navigate(from, { replace: true });

      }
      else { 
        setShowError(true);
        setTimeout(()=>{
          setShowError(false);
        },3*1000);
  
      }
      setProcessing(false);
    }
  };

  return (
    <>
      <div className="container vh-100 d-flex justify-content-center align-items-center">
        <div className="pin-login-panel text-center p-4 rounded rounded-3 animate__animated animate__zoomIn">
          <h2 className="mb-2"></h2>
          {/* <input type="text" value="asdas" id="pinInput" className="form-control pin-input mb-4" maxLength={4} disabled/> */}
          <div className="pad-display fs-2 text-wrap mb-4 p-2 w-100 rounded-3 text-center d-flex align-items-center justify-content-center fw-bold ">
            {showDigits
              ? pinString
              : Array.of(
                  pinString.split("").map(() => {
                    return "o";
                  })
                )}
          </div>

          <div className="row row-pin mb-2">
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="1"
              onClick={onClickDigit}
            >
              1
            </button>
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="2"
              onClick={onClickDigit}
            >
              2
            </button>
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="3"
              onClick={onClickDigit}
            >
              3
            </button>
          </div>
          <div className="row row-pin mb-2">
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="4"
              onClick={onClickDigit}
            >
              4
            </button>
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="5"
              onClick={onClickDigit}
            >
              5
            </button>
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="6"
              onClick={onClickDigit}
            >
              6
            </button>
          </div>
          <div className="row row-pin mb-2">
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="7"
              onClick={onClickDigit}
            >
              7
            </button>
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="8"
              onClick={onClickDigit}
            >
              8
            </button>
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="9"
              onClick={onClickDigit}
            >
              9
            </button>
          </div>
          <div className="row row-pin mb-2">
            <button
              className="btn-pin btn-pin-utility mx-2"
              onClick={() => {
                setShowDigits(!showDigits);
              }}
            >
              <FontAwesomeIcon icon="eye-slash" />
            </button>
            <button
              className="btn-pin btn-pin-digit mx-2"
              data-digit="0"
              onClick={onClickDigit}
            >
              0
            </button>

            <button
              className="btn-pin btn-pin-utility mx-2"
              onClick={() => {
                clearPin();
              }}
            >
              <FontAwesomeIcon icon="arrow-left" />
            </button>
          </div>
           <div className="row row-pin mb-2 text-center">
             <button
               disabled={processing}
               className={
                 showError ? "btn-theme btn-pin-login mx-2 mt-3 animate__animated animate__headShake rounded" : "btn-theme btn-pin-login mx-2 mt-3 rounded"
               }
               onClick={handleLogin}
             >
               {showError ? "Invalid!!" : "Log In"}
             </button>
           </div>
          <div className="row d-none">
            {showError ? 
          <div className="rounded-3 p-2 mb-2 bg-warning text-white" style={{height:'40px'}}>
  Invalid!!
</div> : <></>}
          </div>
          <div className="font-7">{appVersion}</div>
        </div>
      </div>
    </>
  );
};

export default PinLoginPage;
